export default __webpack_public_path__ + "static/iso-9001-seal-b3ca3fcbf6bd3484a30a294bd52e450c.svg";